<script setup lang="ts">
    import Breadcrumbs from '@/components/Breadcrumbs.vue';
    import type { BreadcrumbItemType } from '@/types';
    import Card from '@/components/ui/card/Card.vue';
    import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';

    withDefaults(
        defineProps<{
            breadcrumbs?: BreadcrumbItemType[];
            headerClass?: HTMLAttributes['class'];
        }>(),
        {
            breadcrumbs: () => [],
        },
    );
</script>

<template>
    <Card class="z-10 mx-1.5 mt-1.5 flex min-h-12 flex-row items-center px-5">
        <header :class="cn('overflow-hidden', headerClass)">
            <div class="flex w-full items-center">
                <template v-if="breadcrumbs && breadcrumbs.length > 0">
                    <Breadcrumbs :breadcrumbs="breadcrumbs" />
                </template>
                <slot name="actions" />
            </div>
        </header>
    </Card>
</template>
